<template>
  <div>
    <el-table
      size="mini"
      :data="tableData"
      v-horizontal-scroll
      :header-cell-style="() => `background-color:#F2F6FA;`"
    >
      <el-table-column label="星期" width="160">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.week_day"
            multiple
            class="week-day-selector"
            @change="handleChange"
          >
            <el-option
              v-for="(item, index) in [
                { text: '周日', value: 0 },
                { text: '周一', value: 1 },
                { text: '周二', value: 2 },
                { text: '周三', value: 3 },
                { text: '周四', value: 4 },
                { text: '周五', value: 5 },
                { text: '周六', value: 6 },
              ]"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="上课时间">
        <template slot-scope="scope">
          <step-time-range-selector
            :originStart.sync="scope.row.start_time"
            :originEnd.sync="scope.row.end_time"
            @change="handleChange"
          ></step-time-range-selector>
        </template>
      </el-table-column>
      <el-table-column width="120">
        <template slot-scope="scope">
          <time-step-selector
            :oriStart.sync="scope.row.start_time"
            :oriEnd.sync="scope.row.end_time"
            @change="handleChange"
          ></time-step-selector>
          <el-button
            type="text"
            class="mwow-red"
            @click="deleteLoop(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="add-btn mwow-green" @click="addLoop">
      <i class="el-icon-plus"></i>添加
    </div>
  </div>
</template>
<script>
import timeStepSelector from "@/components/timeStepSelector.vue";
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";

export default {
  name: "classDetailLog",
  components: { timeStepSelector, stepTimeRangeSelector },
  // @Prop() originData!: any;
  props: ["originData"],
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    if (this.originData && this.originData.length > 0) {
      this.tableData = [...this.originData];
    } else {
      this.$nextTick(() => {
        this.addLoop();
      });
    }
  },
  methods: {
    addLoop() {
      const arr = [...this.tableData];
      if (arr.length >= 7) {
        this.$message({
          type: "error",
          message: "最多为7条",
        });
        return false;
      }
      arr.push({
        week_day: [],
        start_time: "12:00",
        end_time: "13:00",
      });
      this.tableData = arr;
      this.handleChange();
    },
    deleteLoop(index) {
      const arr = [...this.tableData];
      arr.splice(index, 1);
      this.tableData = arr;
      this.handleChange();
    },
    handleChange() {
      this.$emit("change", this.tableData);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-button--text {
  font-size: 12px;
}
.add-btn {
  text-align: center;
  line-height: 42px;
  border: 1px solid #e1e5e9;
  border-top: 0;
  cursor: pointer;
}
.step-selector {
  width: 50%;
}
.week-day-selector {
  /deep/.el-select__tags {
    & > span {
      white-space: nowrap;
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
      padding-left: 8px;
      .el-tag {
        display: inline;
        border: 0;
        padding: 0;
        margin: 0;
        &::after {
          content: "、";
        }
        &:last-child {
          &::after {
            display: none;
          }
        }
        .el-icon-close {
          display: none;
        }
      }
    }
  }
}
/deep/.el-table {
  overflow: visible;
  .el-table__body-wrapper {
    overflow: visible;
  }
  .cell {
    overflow: visible;
  }
}
</style>
